import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Register from "./Registration";
import GetFplId from "./pages/GetFplId";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Login from "./Login";
import AdminGate from "./Admin-section/AdminGate";
import Panel from "./Admin-section/Panel";
import ProtectedRoute from "./Admin-section/ProtectedRoute";
import Payment from "./Payment";
import CheckoutWallet from "./components/CheckoutWallet";
import SeasonLeague from "./pages/SeasonLeague/SeasonLeague";
import HeadToHead from "./pages/HeadToHead";
import Leagues from "./Leagues";
import { requestForToken } from "./firebase";
import RefRedirect from "./pages/RefRedirect";
import { refreshToken } from "./utils/auth";
import Contact from "./components/Contact";
import { WhatsAppPromptModal } from "./components/WhatsappPromptModal";
import Install from "./pages/Install";

// NEW: lives inside <Router>, so it can use useLocation to re-check auth on every navigation
function AppContent() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
  }, [location.pathname]); // re-check whenever the route changes (e.g. right after login's navigate())

  return (
    <>
      {isLoggedIn && <WhatsAppPromptModal isLoggedIn={isLoggedIn} />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/get-fpl-id" element={<GetFplId />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/checkout-wallet" element={<CheckoutWallet />} />
        <Route
          path="/panel"
          element={
            <ProtectedRoute>
              <Panel />
            </ProtectedRoute>
          }
        />
        <Route path="/admin-gate" element={<AdminGate />} />
        <Route path="/season-league" element={<SeasonLeague />} />
        <Route path="/head-to-head" element={<HeadToHead />} />
        <Route path="/leagues" element={<Leagues />} />
        <Route path="/ref/:code" element={<RefRedirect />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/install" element={<Install />} />
      </Routes>
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      await refreshToken(); // tries to get new accessToken using cookie; writes to localStorage on success
      setLoading(false);
    };
    initAuth();

    //Ask for push notification token
    requestForToken();

    const isMobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent);

    const handler = (e) => {
      if (!isMobile) return;
      e.preventDefault();
      window.deferredInstallPrompt = e;
      window.dispatchEvent(new Event("install-prompt-ready"));
    };

    const installedHandler = () => {
      window.deferredInstallPrompt = null;
      window.dispatchEvent(new Event("install-prompt-ready"));
    };

    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", installedHandler);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <Router>
        <AppContent />
      </Router>
    </>
  );
}

export default App;
